import React, { useMemo, useState, useContext } from 'react';
import 'prop-types';
import ThemeContext from '../../ThemeProvider/context.js';
import Box from '../../layout/Box/Box.js';
import PanelSteps from '../../panels/PanelSteps/PanelSteps.js';
import useResponsive from '../../../hooks/useResponsive.js';
import styles from './styles.js';

const Btn = props => {
  const {
    children,
    color,
    hoverColor,
    gradient,
    rounded,
    txtColor,
    hoverTxtColor,
    bgColor,
    depth,
    align,
    full,
    style,
    iconLeft,
    iconRight,
    iconCenter,
    iconLoading,
    iconFailed,
    iconSuccess,
    iconHover,
    width: w,
    height,
    whiteSpace,
    padding: p,
    pt: paddingT,
    pe: paddingE,
    pb: paddingB,
    ps: paddingS,
    margin,
    mt,
    me,
    mb,
    ms,
    onClick,
    weight,
    nowrap,
    loading: propLoading,
    failed: propFailed,
    success: propSuccess,
    shake: propShake
  } = props;
  const width = useMemo(() => {
    if (w) {
      return w;
    }
    if (full) {
      return '100%';
    }
    return null;
  }, [w, full]);
  useState(false);
  useState(false);
  useState(false);
  useState(false);
  useState(false);
  const [progress, setProgress] = useState();
  const [hover, setHover] = useState(false);
  const theme = useContext(ThemeContext);
  const breakpoints = theme.mediaQueries;
  const font = useResponsive(props.font, breakpoints);
  const size = useResponsive(props.size, breakpoints);
  const padding = useResponsive(p, breakpoints);
  const pt = useResponsive(paddingT, breakpoints);
  const pe = useResponsive(paddingE, breakpoints);
  const pb = useResponsive(paddingB, breakpoints);
  const ps = useResponsive(paddingS, breakpoints);
  const iconsLeft = [];
  const hasLeftIcon = iconLeft || iconLoading && propLoading || iconFailed && propFailed || iconSuccess && propSuccess;
  let step = 0;
  let adjColor = color;
  if (propLoading) {
    step = 1;
  } else if (propFailed) {
    step = 2;
    adjColor = 'danger';
  } else if (propSuccess) {
    step = 3;
    adjColor = 'success';
  } else if (iconHover && hover) {
    step = 4;
  }
  const classes = styles({
    theme,
    font,
    full,
    size,
    txtColor,
    hoverTxtColor,
    color: adjColor,
    hoverColor,
    gradient,
    align,
    weight,
    whiteSpace,
    shake: propShake,
    hasLeftIcon,
    nowrap,
    height,
    padding,
    pt,
    pe,
    pb,
    ps
  });
  if (hasLeftIcon) {
    iconsLeft.push(/*#__PURE__*/React.createElement("div", {
      key: "icon",
      className: classes.ButtonIconItem
    }, iconLeft));
    iconsLeft.push(/*#__PURE__*/React.createElement("div", {
      key: "loading_icon",
      className: `${classes.ButtonIconItem} ${classes.ButtonIconLoading}`
    }, iconLoading));
    iconsLeft.push(/*#__PURE__*/React.createElement("div", {
      key: "failed_icon",
      className: classes.ButtonIconItem
    }, iconFailed));
    iconsLeft.push(/*#__PURE__*/React.createElement("div", {
      key: "success_icon",
      className: classes.ButtonIconItem
    }, iconSuccess));
    iconsLeft.push(/*#__PURE__*/React.createElement("div", {
      key: "hover_icon",
      className: classes.ButtonIconItem
    }, iconHover));
  }
  const jssClassNames = props.outline ? classes.ButtonOutline : classes.Button;
  const classNames = props.className ? `${jssClassNames} ${props.className}` : jssClassNames;
  return /*#__PURE__*/React.createElement(Box, {
    tag: props.tag,
    type: props.type,
    className: classNames,
    tabIndex: props.tabIndex,
    onClick: onClick,
    onMouseDown: props.onMouseDown,
    onTouchStart: props.onTouchStart,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false),
    style: style,
    href: props.href,
    target: props.target,
    margin: margin,
    depth: depth,
    mt: mt,
    me: me,
    mb: mb,
    ms: ms,
    width: width,
    height: height,
    rounded: rounded,
    bgColor: bgColor
  }, progress && /*#__PURE__*/React.createElement("span", {
    className: "btn__progress",
    width: progress && `${progress}%`
  }), hasLeftIcon && /*#__PURE__*/React.createElement("span", {
    className: classes.ButtonIcon
  }, /*#__PURE__*/React.createElement(PanelSteps, {
    step: step,
    timeout: 150,
    axis: "Y",
    travel: 16
  }, iconsLeft)), children && /*#__PURE__*/React.createElement("span", {
    className: `${classes.ButtonTitle} ${classes.ButtonType}`
  }, iconCenter && /*#__PURE__*/React.createElement("span", {
    className: classes.ButtonIconCenter
  }, iconCenter), children), iconRight && /*#__PURE__*/React.createElement("span", {
    className: classes.ButtonIcon
  }, iconRight));
};
Btn.defaultProps = {
  font: 'p',
  color: 'primary',
  size: 'md',
  align: '',
  icon: '',
  iconFont: 'sf',
  iconPrefix: '',
  tag: 'button',
  txtColor: '#fff',
  rounded: true
};

export { Btn as default };
